import SampleScheduleReport from "../components/portal/SampleScheduleReport";
import FileUploadPage from "../components/portal/fileUpload/FileUploadPage";
import LeadServiceLineIndex from "../components/portal/leadServiceLineIndex";

export const portalRoutes = [
  {
    path: "/portal/lead-service-line-index",
    component: LeadServiceLineIndex
  },
  {
    path: "/portal/file-upload",
    component: FileUploadPage
  },
  {
    path: "/portal/sample-schedule-report",
    component: SampleScheduleReport
  }
];
